import { useEffect } from 'react';

/**
 * Like useEffect, but its execution can be enabled/disabled.
 * @param effect
 * @param dependencies
 * @param isEnabled Isn't considered dependency.
 */
export const useConditionalEffect = (
  effect: React.EffectCallback,
  dependencies: React.DependencyList,
  isEnabled: boolean,
) => {
  useEffect(() => {
    if (isEnabled) {
      return effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- dependencies is the caller-provided list; effect and isEnabled are intentionally excluded (see JSDoc)
  }, [...dependencies]);
};
